import { DomainPreferences } from '../../../../api/types';
import { LanguageString, PageConfig } from '../../../../common/components/dashboards/types';
import { StoryboardDateUtils } from '../../utils';
import {
  getAttritionTTMFactboxConfig,
  getAvgAgeFactboxConfig,
  getAvgTenureFactboxConfig,
  getCustomSurveyFactboxConfig,
  getGenderRatioFactboxConfig,
  getIndividualsFactboxConfig,
  getInternalMobilityFactboxConfig,
  getJoinersFactboxConfig,
  getLeaversFactboxConfig,
  getMonthlyOtFactboxConfig,
  getPercFemaleManagerFactboxConfig,
} from './human-capital-chart-helpers';

export const getMixiHumanCapitalDbPageConfig = (
  storyboardDateUtils: StoryboardDateUtils,
  domainPreferences: DomainPreferences,
  pageOption: {
    pageId: number;
    dashboardId: string;
    title: LanguageString;
  }
): PageConfig => {
  const { pageId, dashboardId, title } = pageOption;
  const pageComponents = [
    getIndividualsFactboxConfig(storyboardDateUtils),
    getGenderRatioFactboxConfig(storyboardDateUtils),
    getAvgAgeFactboxConfig(storyboardDateUtils),
    getAvgTenureFactboxConfig(storyboardDateUtils),
    getPercFemaleManagerFactboxConfig(storyboardDateUtils),
    getJoinersFactboxConfig(storyboardDateUtils),
    getLeaversFactboxConfig(storyboardDateUtils),
    getAttritionTTMFactboxConfig(storyboardDateUtils),
    getMonthlyOtFactboxConfig(storyboardDateUtils),
    getCustomSurveyFactboxConfig(storyboardDateUtils, domainPreferences),
    getInternalMobilityFactboxConfig(storyboardDateUtils),
  ];

  const pageConfig: PageConfig = {
    pageId: pageId.toString(),
    dashboardId,
    pageNumber: pageId,
    enabled: true,
    title,
    pageOptions: {
      displayOptions: {
        enabled: true,
      },
      timeSlider: {
        enabled: false,
      },
      filterTray: {
        enabled: true,
      },
      dataView: {
        enabled: false,
      },
      segmentationLevel1: {
        enabled: false,
      },
      segmentationLevel2: {
        enabled: false,
      },
      benchmark: {
        enabled: false,
      },
      forecast: {
        enabled: false,
      },
    },
    gridCols: 30,
    gridRows: 2,
    components: [...pageComponents],
  };
  return pageConfig;
};
